export default {"src":"/_next/static/media/EDR.5a97d11a.svg","height":18,"width":18};